import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Tooltip,
} from "@mui/material";
import CalenderRed from "../../../src/assests/images/calendar-red.svg";
import ScheduledTask from "./ScheduledTask";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { assignTask, assignTasktest, cohortassign, cohortAssignfinal, getdropdowntasknames } from "../../pages/tasks-assigning/api";
import { getToken } from "../../utils/utils";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DropDownFilter, { Option } from "../../pages/reports/RetailerAll/DropDownFilter";
import CohortView from "./CohortView";
import { AxiosError } from "axios";


interface TaskData { task_name: string; credit_points: string; durations: string; }
interface ScheduledAssignProps {
  value: string;
  cohortIds: string[];
  selectedDate1: Date | null;
  setSelectedDate1: Dispatch<SetStateAction<Date | null>>;
  selectedTime: string | null;
  setSelectedTime: Dispatch<SetStateAction<string | null>>;
  cohorttaskid: string;
  selected: number[];
  unselectedIds: number[];
  missingidssssss: number[];
  checkbaledata: any[];
 gettaskdata: TaskData | null;
  setGetTaskData: React.Dispatch<React.SetStateAction<TaskData | null>>;
   selectedRows: number[];
  setSelectedRows: React.Dispatch<React.SetStateAction<number[]>>;
  assignedCount: number;
    selectedCohortStatuses: Record<string, string>;
  setSelectedCohortStatuses: React.Dispatch<React.SetStateAction<Record<string, string>>>;
   selectedTaskIds: string[];
  setSelectedTaskIds: React.Dispatch<React.SetStateAction<string[]>>;
  userdatadata:string
      cohortSchedules: { [key: string]: string };
  setCohortSchedules: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
   totalCreditPoints: number;
  setTotalCreditPoints: React.Dispatch<React.SetStateAction<number>>;
  totalRetailers: number;
  setTotalRetailers: React.Dispatch<React.SetStateAction<number>>;

}

interface Task {
  id: string;
  name: string;
}

export default function ScheduledAssign({
  value,
  cohortIds,
  setSelectedDate1,
  selectedDate1,
  selectedTime,
  setSelectedTime,
  cohorttaskid,
  selected,
  unselectedIds,
  checkbaledata,
  missingidssssss,
  selectedRows, setSelectedRows,
  gettaskdata, setGetTaskData ,
  assignedCount,
  selectedCohortStatuses,
  setSelectedCohortStatuses,
    selectedTaskIds,        // ✅ new prop
  setSelectedTaskIds,  
  userdatadata,
  cohortSchedules, setCohortSchedules,
    totalCreditPoints,
  setTotalCreditPoints,
  totalRetailers,
  setTotalRetailers
}: ScheduledAssignProps) {
  const { id, cohort_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedTasks1, setSelectedTasks1] = useState<string[]>([]);
  const [open, setOpen] = useState(false);
  const [endDate1, setEndDate1] = useState<Date | null>(null);
  const [endDate2, setEndDate2] = useState<Date | null>(null);
  const formattedEndDate1 = endDate1 ? endDate1.toLocaleDateString("en-GB") : "";
  const formattedEndTime1 = endDate1
    ? endDate1.toLocaleTimeString("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
}):"";
  const formattedEndDate2 = endDate2 ? endDate2.toLocaleDateString("en-GB") : "";
  const formattedEndTime2 = endDate2
    ? endDate2.toLocaleTimeString("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
}):"";




  const [buttonpresent, setbuttonpresent] = useState(false);
  const [totalcountoutletsh, setTotalCountOutlets] = useState<string[]>([]);
  const { showAlert } = useAlert();
  const [tasks, setTasks] = useState<Task[]>([]);
  const token = getToken();
console.log(cohortIds, "cohortIds78888888888888")
useEffect(() => {
  const fetchTasks = async () => {
    if (!cohortIds || cohortIds.length === 0) return;

    try {
      // Convert string array to number array if necessary
      const cohortIdsNumbers = cohortIds.map(id => Number(id));

      const taskData = await getdropdowntasknames({ cohort_ids: cohortIdsNumbers });
      setTasks(taskData.data.data.allinone);
    } catch (err) {
      console.error("Failed to fetch tasks:", err);
    }
  };

  fetchTasks();
}, [cohortIds]);



  const isCohortView = location.pathname.replace(/\/$/, "") === "/cohorts-view";

  useEffect(() => {
    if (location.state?.valuetabsdatapagelengthselectedRows) {
      setTotalCountOutlets(location.state.valuetabsdatapagelengthselectedRows);
    }
  }, [location.state]);

  const handleOpen = () => {
    console.log("handleOpen called, setting open to true");
    setOpen(true);
  };

  const handleClose = () => {
    console.log("handleClose called, resetting open and buttonpresent");
    setOpen(false);
    setbuttonpresent(false);
    setSelectedDate1(null);
    setSelectedTime(null);
  };

  console.log(open, "openopenopen888888888888");

  const handleAssignNowClickcohort = async () => {
    try {
      if (Number(cohort_id)) {
        const response = await cohortAssignfinal(token, String(cohorttaskid), missingidssssss, Number(cohort_id));
        if (response.data.success) {
          showAlert("For cohort user assigned successfully!", "success");
          navigate(`/cohort-user/${cohort_id}`);
          setTimeout(() => window.location.reload(), 100);
        }
      }
    } catch (error) {
      console.error("Error assigning task:", error);
      showAlert("An error occurred while user assigned for cohort", "error");
    }
  };

  const handleAssignNowClick = async () => {
    try {
      if (Number(value) === 2) {
        const numericIds = selectedRows.map(Number);
        const response = await assignTasktest(token, String(id), numericIds, formattedEndDate1,
          formattedEndTime1);
        if (response.data.success) {
          showAlert("Task is assigned successfully!", "success");
          // navigate(`/assign-task/${id}`);
          // setTimeout(() => window.location.reload(), 100);
        }
      }
    } catch (error) {
      let errorMessage = "An error occurred while assigning the task to cohorts";
         if (error instanceof AxiosError) {
           // Axios error detected
           const serverError = error.response?.data?.error || error.response?.data?.message;
           if (serverError?.includes(" End date/time must be in the future")) {
             errorMessage = "Failed to assign tasks: End date/time must be in the future.";
           } else {
             errorMessage = serverError || error.message;
           }
         } else if (error instanceof Error) {
           // Fallback for normal JS errors
           errorMessage = error.message;
         }
     
         console.error("Error assigning task to cohorts:", error);
         showAlert(errorMessage, "error");
       }
     };
     
  console.log(value, "value333")
  const handlecohortassigntaskNowClick = async () => {
    try {
      if (Number(value) === 1) {
        const response = await cohortassign(token, selectedTasks1, cohortIds, formattedEndDate2,
          formattedEndTime2);
        if (response.data.success) {
          showAlert("Cohort assigned successfully!", "success");
          navigate(`/cohorts-view`);
          setTimeout(() => window.location.reload(), 100);
        }
      }
    } catch (error) {
     let errorMessage = "An error occurred while assigning the task to cohorts";
         if (error instanceof AxiosError) {
           // Axios error detected
           const serverError = error.response?.data?.error || error.response?.data?.message;
           if (serverError?.includes("start date and time")) {
             errorMessage = "Failed to assign tasks: Both the start date and time and the end date and time must be in the future.";
           } else {
             errorMessage = serverError || error.message;
           }
         } else if (error instanceof Error) {
           // Fallback for normal JS errors
           errorMessage = error.message;
         }
     
         console.error("Error assigning task to cohorts:", error);
         showAlert(errorMessage, "error");
       }
     };
     

  const handleCombinedAssignClick1 = async () => {
    console.log("handleCombinedAssignClick called with:", { value, buttonpresent, cohort_id, isCohortView });
    try {

      if (Number(cohort_id)) {
        await handleAssignNowClickcohort();
      } else if (Number(value) === 2) {
        await handleAssignNowClick();
      } else if (Number(value) === 1) {
        await handlecohortassigntaskNowClick();
      } else {
        console.error("Invalid value for assignment");
        showAlert("Invalid value provided for assignment", "error");
      }
    } catch (error) {
      console.error("Error in combined assign function:", error);
      showAlert("An error occurred while assigning the task", "error");
    }
  };


  const handleClick2 = async () => {
    console.log("handleClick2 triggered", { isCohortView, value, cohort_id });

    try {
      setbuttonpresent(true);


    } catch (error) {
      console.error("Error in handleClick2:", error);
      showAlert("An error occurred while assigning", "error");
    }
  };

  const cohortUserPathPattern = /^\/cohort-user(\/\d+)?$/;
  const shouldHideAssignButtons = cohortUserPathPattern.test(location.pathname);

  console.log("Current pathname:", location.pathname, "shouldHideAssignButtons:", shouldHideAssignButtons);
  console.log(buttonpresent, "buttonpresent88899999");
console.log(selectedCohortStatuses, "selectedCohortStatuses")
const anyTrue = Object.values(selectedCohortStatuses).some(
  status => typeof status === "boolean" && status === true
);
const shouldShowAssignButton = (() => {
  const values = Object.values(selectedCohortStatuses);

  // Case 1: Empty object — show button
  if (values.length === 0) return true;

  // Case 2: Only {490: true}
  if (values.length === 1 && String(values[0]) === "true") return true;

  // Case 3: Any “unknown” → hide button
  if (values.some((status) => String(status) === "unknown")) return false;

  // Default → hide
  return false;
})();
console.log(shouldShowAssignButton, "shouldShowAssignButt5225555on",Object.keys(cohortSchedules).length,"cohortSchedules",cohortSchedules)
// Render dropdown only if no true exists or object is empty

const allUnknown = Object.values(selectedCohortStatuses).every(
  (status) => status === "unknown"
);

const shouldRenderDropdown =
  Object.keys(selectedCohortStatuses).length === 0 || allUnknown;


// const shouldRenderDropdown =
//   Object.keys(selectedCohortStatuses).length === 0 || !anyTrue;
console.log(shouldRenderDropdown, "shouldRenderDropdown788888888")
console.log(location.pathname, "location.pathnamelocation.pathname",selectedCohortStatuses)
console.log(cohortSchedules, "cohortSchedulescohortSchedulescohortSchedules")
  return (
    <div>
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            padding: "10px 32px",
            borderTop: "1px solid #d8d8d8",
            marginTop: "30px",
            position: "fixed",
            bottom: "0",
            width: "82%",
            minHeight: "60px",
            "@media (max-width: 1366px)": {
              width: "80%",
            },
            "@media (max-width: 1280px)": {
              width: "77.8%",
              padding: "10px 20px",
            },
          }}
        >

          <Box>
            <Link
              to={
                location.pathname.startsWith("/cohort-user")
                  ? "/cohorts-view"
                  : "/manage-task"
              }
              style={{ textDecoration: "none" }}
            >
              <Typography sx={{ color: "#C8172F", fontSize: "14px", cursor: "pointer" }}>
                <ArrowBackIcon sx={{ fontSize: "16px", marginRight: "5px", position: "relative", top: "4px" }} /> Back
              </Typography>
            </Link>
          </Box>
          <Box>
            {!shouldHideAssignButtons && (
              <>
              {/* {shouldRenderDropdown && ( */}
           
    {(location.pathname.startsWith("/cohorts-view")
      ? shouldRenderDropdown
      : id && (userdatadata === "Schedule now" || userdatadata === "No task mapping found")) && (

                <Tooltip title="Schedule Assign" arrow>
                  <Button
                    sx={{
                      border: "1px solid #C8172F",
                      color: "#C8172F",
                      textTransform: "capitalize",
                      marginRight: "20px",
                      padding: "6px 20px",
                      borderRadius: "10px",
                      alignItems: "center",
                      background: "#fff",
                      gap: "10px",
                      height: "48px",
                      "&:hover": {
                        background: "#fff",
                      },
                    }}
                    onClick={() => {
                      console.log("Schedule Assign clicked, keeping buttonpresent false");
                      handleOpen();
                    }}
                  >
                    <img
                      src={CalenderRed}
                      alt="Icon"
                      style={{ width: "20px", height: "20px", objectFit: "contain" }}
                    />
                    Schedule Assign
                  </Button>
                </Tooltip>
                )}
                {/* {shouldShowAssignButton && ( */}
                 {(location.pathname.startsWith("/cohorts-view")
      ? shouldShowAssignButton || Object.keys(cohortSchedules).length === 0 ||  Object.values(cohortSchedules).every(value => value === '0')
      : id && (userdatadata === "Assign now" || userdatadata === "No task mapping found")) && (

                <Tooltip title="Assign Now" arrow>
                  <Button
                    sx={{
                      background: "#C8172F",
                      color: "#fff",
                      fontSize: "14px",
                      textTransform: "capitalize",
                      padding: "8px 30px",
                      borderRadius: "10px",
                      marginRight: "0px",
                      height: "48px"
                    }}
                    onClick={() => {
                      console.log("Schedule Assign clicked, keeping buttonpresent false");
                      handleOpen();
                      handleClick2()

                    }}
                  >
                    Assign Now
                  </Button>
                </Tooltip>
                )}
              </>
            )}
          </Box>
        </Box>
      </Box>

      <ScheduledTask  totalCreditPoints={totalCreditPoints}
        setTotalCreditPoints={setTotalCreditPoints}
        totalRetailers={totalRetailers}
        setTotalRetailers={setTotalRetailers}
      userdatadata={userdatadata}
        selectedTaskIds={selectedTaskIds}            // ✅ pass it here
  setSelectedTaskIds={setSelectedTaskIds} 
       selectedCohortStatuses={selectedCohortStatuses}
      setSelectedCohortStatuses={setSelectedCohortStatuses}
       assignedCount={assignedCount} 
 gettaskdata={gettaskdata}
    setGetTaskData={setGetTaskData}
      selectedRows={selectedRows}
    setSelectedRows={setSelectedRows}

        selectedTasks1={selectedTasks1}
        setSelectedTasks1={setSelectedTasks1}
        setEndDate1={setEndDate1}        // 👈 pass down
        endDate1={endDate1}
        setEndDate2={setEndDate2}        // 👈 pass down
        endDate2={endDate2}
        unselectedIds={unselectedIds}
        missingidssssss={missingidssssss}
        checkbaledata={checkbaledata}
        selected={selected}
        open={open}
        onClose={handleClose}
        task_id={""}
        user_ids={[]}
        date={""}
        time={""}
        cohortIds={cohortIds}
        value={value}
        setSelectedDate1={setSelectedDate1}
        selectedDate1={selectedDate1}
        setSelectedTime={setSelectedTime}
        selectedTime={selectedTime}
        cohorttaskid={cohorttaskid}
        tasks={tasks}
        setTasks={setTasks}
        buttonpresent={buttonpresent}
        handleCombinedAssignClick1={handleCombinedAssignClick1}
      />
    </div>
  );
}